import React from "react";
import { Link } from "gatsby";
import Typography from "get-life-storybook-ts/lib/atoms/Typography/Typography";
import TrustPilotLogoBlack from "./TrustPilotLogoBlack";
import { FiveStars, TrustPilotLogo } from "./TrustPilotDS";
import { translate } from "../../contexts/i18n.context";

interface TrustPilotStaticWidgetProps {
  score?: string;
  excellentText?: string;
  excellentLink?: string;
}

const TrustPilotStaticWidget = ({ score, excellentText, excellentLink }: TrustPilotStaticWidgetProps) => {

  if (process.env.GATSBY_APP_LOCALE === "it") {
    return (
      <a
        href={excellentLink || "https://it.trustpilot.com/review/life5.it"}
        target="_blank"
        rel="noopener noreferrer"
        className="no-underline block text-black"
      >
        <p className="BodyS font-normal space-x-[8px] text-center">
          <FiveStars className="inline-block mt-[-3px]" />
          <span>
            <b>Eccellente | {score || "4.7"}</b> {excellentText || "su 5 con oltre 10.000 clienti"}
          </span>
          <TrustPilotLogo className="inline-block mt-[-3px]" />
        </p>
      </a>
    )
  }

  return (
    <Link
      to={translate("truspilot.link")}
      className="no-underline"
      target="_blank"
    >
      <div className="flex items-center justify-center flex-row gap-1 font-DM font-normal text-black">
        <Typography variant="BodyMedium" weight="700" text={translate("truspilot.excellent")} />
        <Typography variant="BodyMedium" text=" | " />
        {score && <Typography variant="BodyMedium" text={score} weight="700" />}
        <Typography variant="BodyMedium" text={translate("truspilot.truspilot")} />

      </div>
      <div className="flex items-center justify-center flex-row gap-1 ">
        <TrustPilotLogoBlack />
      </div>
    </Link>
  );
};

export default TrustPilotStaticWidget;
